import React from 'react'

const Categories = ( { filterItems }) => {
  return (
    <div className='btn-container'>
      <button className='filter-btn' onClick={() => filterItems('all')}>All</button>
      <button className='filter-btn' onClick={() => filterItems('entrees')}>Entrees</button>
      <button className='filter-btn' onClick={() => filterItems('rolls')}>Rolls</button>
      <button className='filter-btn' onClick={() => filterItems('sashimi')}>Sashimi</button>
      <button className='filter-btn' onClick={() => filterItems('drinks')}>Drinks</button>
    </div>
  )
}

export default Categories